'use client'

import Link from 'next/link'
import { PageHeader, PageHeaderHeading } from '@/components/landing/page-header'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { FaqStructuredData } from '../vemmerui/structured'

const faqs = [
  {
    question: 'What does BacklinkGPT do?',
    answerText:
      'BacklinkGPT automates your link-building. Our AI Agent extracts relevant keywords from your site, identifies top backlink prospects, sources their contact information, and crafts personalized outreach messages.',
    answerDisplay: (
      <>
        BacklinkGPT automates your link-building. Our AI Agent extracts relevant keywords from your
        site, identifies top backlink prospects, sources their contact information, and crafts
        personalized outreach messages.
      </>
    ),
  },
  {
    question: 'How do I get started with BacklinkGPT?',
    answerText:
      "It's a simple 3-step process: 1. Create an Organization to manage your campaigns. 2. Add your domain. 3. Let our AI Agent handle the prospecting and outreach, which you can then review and act upon.",
    answerDisplay: (
      <>
        It's a simple 3-step process: 1. Create an Organization to manage your campaigns. 2. Add
        your domain. 3. Let our AI Agent handle the prospecting and outreach, which you can then
        review and act upon.
      </>
    ),
  },
  {
    question: 'How does the AI-generated outreach work?',
    answerText:
      'BacklinkGPT leverages advanced AI language models like GPT-4 and Claude 3.7 Sonnet to craft highly personalized and relevant outreach messages, designed to improve your chances of securing valuable backlinks.',
    answerDisplay: (
      <>
        BacklinkGPT leverages advanced AI language models like GPT-4 and Claude 3.7 Sonnet to craft
        highly personalized and relevant outreach messages, designed to improve your chances of
        securing valuable backlinks.
      </>
    ),
  },
  {
    question: 'What are the key features of BacklinkGPT?',
    answerText:
      'Key features include AI-driven outreach personalization, one-click link prospecting, automated contact discovery (email & LinkedIn contacts), detailed domain/URL analysis, opportunity conversion tracking, and backlink monitoring.',
    answerDisplay: (
      <>
        Key features include AI-driven outreach personalization, one-click link prospecting,
        automated contact discovery (email & LinkedIn contacts), detailed domain/URL analysis,
        opportunity conversion tracking, and backlink monitoring.
      </>
    ),
  },
  {
    question: 'Is BacklinkGPT free to use?',
    answerText:
      'While our main subscription plans are paid, we offer a selection of free SEO tools for you to explore some of our capabilities.',
    answerDisplay: (
      <>
        While our main subscription plans are paid, we do offer a selection of
        <Link className="p-1 underline" href={'/free-seo-tools'}>
          free tools
        </Link>
        for you to explore some of our capabilities.
      </>
    ),
  },
  {
    question: 'What subscription plans are available?',
    answerText:
      'We offer a Pro Plan for individuals, an Ultra Plan for growing businesses, and custom Enterprise solutions. All core features like unlimited AI-Personalized Outreach, 1-Click Link Prospecting, and Automated Contact Discovery are included, with plans varying by seat limits and advanced options.',
    answerDisplay: (
      <>
        We offer a Pro Plan for individuals ($49.99/month), an Ultra Plan for growing businesses
        ($99.99/month), and custom Enterprise solutions. All core features like unlimited
        AI-Personalized Outreach, 1-Click Link Prospecting, and Automated Contact Discovery are
        included, with plans varying by seat limits and advanced options.
      </>
    ),
  },
  {
    question: 'Is my data secure with BacklinkGPT?',
    answerText:
      'Yes, data security is a top priority. We implement industry-standard security measures to ensure your data is protected and stored safely.',
    answerDisplay: (
      <>
        Yes, data security is a top priority. We implement industry-standard security measures to
        ensure your data is protected and stored safely.
      </>
    ),
  },
  {
    question: 'Who created BacklinkGPT?',
    answerText:
      'BacklinkGPT was founded by Felix Vemmer, a digital marketer who identified the need for a more efficient and AI-driven approach to link-building outreach.',
    answerDisplay: (
      <>
        BacklinkGPT was founded by Felix Vemmer, a digital marketer who identified the need for a
        more efficient and AI-driven approach to link-building outreach.
      </>
    ),
  },
]

export const Faq = () => {
  return (
    <>
      <FaqStructuredData
        mainEntity={faqs.map((faq) => ({
          question: faq.question,
          answer: faq.answerText,
        }))}
      />
      <PageHeader>
        <PageHeaderHeading className="text-xl md:text-4xl" level="h2">
          FAQ
        </PageHeaderHeading>

        <div className="container mx-auto w-full md:mx-auto md:w-[1000px] md:max-w-3xl">
          <Accordion type="single" collapsible defaultValue="item-1">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index + 1}`}>
                <AccordionTrigger className="text-left">{faq.question}</AccordionTrigger>
                <AccordionContent>
                  <div>{faq.answerDisplay}</div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </PageHeader>
    </>
  )
}
